"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.start.recording': 'Avvia Registrazione',
    'conversation.start.failed': 'Impossibile avviare la conversazione',
};
